import { toast } from 'react-toastify';

/**
 * Hide toast container while the import panel is open so notifications do not
 * cover the Import button. Prefer CSS over dropping Toast() calls — upload
 * success/error toasts still fire (including right after closeImport).
 *
 * While hidden, toast timers are paused (autoClose: false) and resumed when the
 * panel closes so completion notifications are not lost unseen (PCS-11224 QA).
 */
export const IMPORT_SCREEN_CLASS = 'import-screen-active';
export const IMPORT_TOAST_RESUME_AUTO_CLOSE = 7000;

let importScreenToastsHidden = false;
/** @type {Map<string|number, number>} toastify id -> autoClose ms to restore */
const deferredToastAutoClose = new Map();
/** @type {null | (() => void)} */
let pauseActiveToastHandler = null;

export function isImportScreenToastsHidden() {
  return importScreenToastsHidden;
}

/**
 * Toast module registers how to pause the currently visible toast when import opens.
 */
export function registerImportToastPauseHandler(handler) {
  pauseActiveToastHandler = typeof handler === 'function' ? handler : null;
}

export function deferImportToast(toastId, autoCloseMs = IMPORT_TOAST_RESUME_AUTO_CLOSE) {
  if (toastId == null) return;
  deferredToastAutoClose.set(
    toastId,
    typeof autoCloseMs === 'number' && autoCloseMs > 0 ? autoCloseMs : IMPORT_TOAST_RESUME_AUTO_CLOSE,
  );
}

function resumeDeferredToasts() {
  deferredToastAutoClose.forEach((autoCloseMs, toastId) => {
    if (toast.isActive(toastId)) {
      toast.update(toastId, { autoClose: autoCloseMs });
    }
  });
  deferredToastAutoClose.clear();
}

export function setImportScreenToastsHidden(hidden) {
  const wantHidden = Boolean(hidden);
  document.body.classList.toggle(IMPORT_SCREEN_CLASS, wantHidden);

  // Idempotent: openImport + Import sync must not resume then re-pause (breaks
  // react-toastify@7 autoClose after toast.update).
  if (wantHidden === importScreenToastsHidden) {
    return;
  }

  if (wantHidden) {
    importScreenToastsHidden = true;
    if (pauseActiveToastHandler) pauseActiveToastHandler();
    return;
  }

  importScreenToastsHidden = false;
  resumeDeferredToasts();
}
